import { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import LoadingComponent from '../../../../Components/LoadingComponent';
import { useSelector } from 'react-redux';
import { fetchWrapper } from '../../../../_helpers/fetchWrapper';
import { FaUserGraduate, FaUserAlt, FaBookReader, FaListUl } from 'react-icons/fa';
import { FormattedMessage } from 'react-intl';
import { EnglishGender, NepaliGender } from '../../../../_helpers/_variables';
import { toNepaliNumber } from '../../../../_helpers/_methods';

function EventOverview() {
  const { event } = useSelector((state) => state.event);
  const local = useSelector((state) => state.local.local);
  const [eventStats, setEventStats] = useState({});
  const [genderStats, setGenderStats] = useState({});
  const [ethenicityStats, setEthenicityStats] = useState({});
  const [employeeTypeStats, setEmployeeTypeStats] = useState({});
  const [loadingEventStats, setLoadingEventStats] = useState(true);

  useEffect(() => {
    const generateGenderData = (genderData) => {
      let genderStats = [];
      let genderLabels = Object.keys(genderData).map((gender) => {
        if (local === 'en') {
          return EnglishGender[gender];
        } else {
          return NepaliGender[gender];
        }
      });
      let total = Object.values(genderData).reduce((total, num) => {
        return total + num;
      });
      if (total === 0) {
        Object.values(genderData).forEach((genderCount) => {
          genderStats.push(genderCount);
        });
      } else {
        Object.values(genderData).forEach((genderCount) => {
          genderStats.push((genderCount / total) * 100);
        });
      }
      setGenderStats({
        series: genderStats,
        labels: genderLabels
      });
    };

    const generateEthenicityData = (ethenicityData) => {
      let data = [];
      let xaxisCategories = [];

      ethenicityData.forEach((ethenicity) => {
        if (ethenicity.subgroups?.length > 0) {
          ethenicity.subgroups.forEach((sub) => {
            data.push(sub.count);
            xaxisCategories.push(`${sub.title} (${ethenicity.ethenicity.title})`);
          });
        } else {
          data.push(ethenicity.ethenicity.count);
          xaxisCategories.push(ethenicity.ethenicity.title);
        }
      });
      setEthenicityStats({
        ethenicityData: data,
        xaxisCategories: xaxisCategories
      });
    };

    const generateEmployeeTypeData = (employeeTypeData) => {
      let data = [];
      let xaxisCategories = [];

      employeeTypeData.forEach((employeeType) => {
        if (employeeType.subgroups?.length > 0) {
          employeeType.subgroups.forEach((sub) => {
            data.push(sub.count);
            xaxisCategories.push(`${sub.title} (${employeeType.ethenicity.title})`);
          });
        } else {
          data.push(employeeType.employeeType.count);
          xaxisCategories.push(employeeType.ethenicity.title);
        }
      });
      setEmployeeTypeStats({
        employeeTypeData: data,
        xaxisCategories: xaxisCategories
      });
    };
    const getEventStats = async () => {
      try {
        setLoadingEventStats(true);
        let url = `/event/${event.id}/stats/`;
        const response = await fetchWrapper.get(url);
        if (response) {
          setEventStats(response?.data);
          generateGenderData(response.data.gender);
          generateEthenicityData(response.data.ethenicity);
          generateEmployeeTypeData(response.data.employee_type);
        }
        setLoadingEventStats(false);
      } catch (error) {
        setLoadingEventStats(false);
        console.log(error);
      }
    };

    if (event?.id) {
      getEventStats();
    }
  }, [event?.id]);

  return (
    <>
      {loadingEventStats ? (
        <LoadingComponent />
      ) : (
        <>
          <div className="row">
            <div className="col-sm-6 col-xl-3 mb-3 mb-xl-6">
              <div className="card card-sm h-100">
                <div className="card-body">
                  <div className="row">
                    <div className="col">
                      <div className="d-flex">
                        <div className="flex-shrink-0 text-muted">
                          <FaUserAlt size={25} />
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <h4 className="mb-1 text-muted">
                            <FormattedMessage id="participants" />
                          </h4>
                          <span className="d-block fs-5">
                            {local === 'ne'
                              ? toNepaliNumber(eventStats.participants)
                              : eventStats.participants}{' '}
                            <span className="text-muted fs-6">
                              /{' '}
                              {local === 'ne'
                                ? toNepaliNumber(event.expected_participant_count)
                                : event.expected_participant_count}{' '}
                              <FormattedMessage id="expected" />
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-xl-3 mb-3 mb-xl-6">
              <div className="card card-sm h-100">
                <div className="card-body">
                  <div className="row">
                    <div className="col">
                      <div className="d-flex">
                        <div className="flex-shrink-0 text-muted">
                          <FaUserGraduate size={25} />
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <h4 className="mb-1 text-muted">
                            <FormattedMessage id="resourcePersons" />{' '}
                          </h4>
                          <span className="d-block fs-5 ">
                            {local === 'ne'
                              ? toNepaliNumber(eventStats.resource_persons)
                              : eventStats.resource_persons}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-xl-3 mb-3 mb-xl-6">
              <div className="card card-sm h-100">
                <div className="card-body">
                  <div className="row">
                    <div className="col">
                      <div className="d-flex">
                        <div className="flex-shrink-0 text-muted">
                          <FaListUl size={25} />
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <h4 className="mb-1 text-muted">
                            <FormattedMessage id="event.sessions" />
                          </h4>
                          <span className="d-block fs-5">
                            {local === 'ne'
                              ? toNepaliNumber(eventStats.sessions)
                              : eventStats.sessions}
                            <span className="badge bg-soft-dark text-dark rounded-pill ms-1">
                              {/* //TODO +4 ended today */}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-xl-3 mb-3 mb-xl-6">
              <div className="card card-sm h-100">
                <div className="card-body">
                  <div className="row">
                    <div className="col">
                      <div className="d-flex">
                        <div className="flex-shrink-0 text-muted">
                          <FaBookReader size={25} />
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <h4 className="mb-1 text-muted">
                            <FormattedMessage id="event.knowledgeModules" />
                          </h4>
                          <span className="d-block fs-5">
                            {local === 'ne'
                              ? toNepaliNumber(eventStats.courses)
                              : eventStats.courses}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <div className="card card-sm h-100">
                <div className="card-body">
                  <ReactApexChart
                    options={{
                      labels: genderStats?.labels || [],
                      title: {
                        text: local === 'ne' ? 'सहभागीहरू' : 'Participants',
                        align: 'left'
                      }
                    }}
                    series={genderStats?.series || []}
                    type="donut"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="card card-sm h-100">
                <div className="card-body">
                  <ReactApexChart
                    options={{
                      chart: {
                        type: 'bar',
                        height: 430
                      },
                      title: {
                        text:
                          local === 'ne' ? 'सहभागीहरूको समूह/वर्ग' : 'Ethnicity of Participants',
                        align: 'left'
                      },
                      plotOptions: {
                        bar: {
                          dataLabels: {
                            position: 'top'
                          }
                        }
                      },
                      dataLabels: {
                        enabled: true,
                        offsetX: -6,
                        style: {
                          fontSize: '12px',
                          colors: ['#fff']
                        }
                      },
                      stroke: {
                        show: true,
                        width: 1,
                        colors: ['#fff']
                      },
                      tooltip: {
                        shared: true,
                        intersect: false
                      },
                      xaxis: {
                        categories: ethenicityStats.xaxisCategories
                      }
                    }}
                    series={[
                      {
                        data: ethenicityStats.ethenicityData
                      }
                    ]}
                    type="bar"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="card card-sm h-100">
                <div className="card-body ">
                  <ReactApexChart
                    options={{
                      chart: {
                        type: 'bar',
                        height: 430
                      },
                      title: {
                        text: local === 'ne' ? 'सहभागीको प्रकार' : 'Participant types',
                        align: 'left'
                      },
                      plotOptions: {
                        bar: {
                          dataLabels: {
                            position: 'top'
                          }
                        }
                      },
                      dataLabels: {
                        enabled: true,
                        offsetX: -6,
                        style: {
                          fontSize: '12px',
                          colors: ['#fff']
                        }
                      },
                      stroke: {
                        show: true,
                        width: 1,
                        colors: ['#fff']
                      },
                      tooltip: {
                        shared: true,
                        intersect: false
                      },
                      xaxis: {
                        categories: employeeTypeStats.xaxisCategories
                      }
                    }}
                    series={[
                      {
                        data: employeeTypeStats.employeeTypeData
                      }
                    ]}
                    type="bar"
                  />
                </div>
              </div>
            </div>
          </div>
          {/* //TODO
          <div className="row">
            <div className="col-lg-6">
              <div className="card event-activity-wrapper">
                <div className="card-body">
                  <h5 className="mb-6">Recent Activity</h5>
                  <div className="list-group list-group-flush list-group-borderless ms-4">
                    <div className="list-group-item px-2 py-0">
                      <div className="border-start">
                        <div className="d-flex ms-n6 pb-6">
                          <div className="flex-none me-3">
                            <div className="icon icon-shape text-base w-12 h-12 bg-soft-primary text-primary rounded-circle">
                              <i className="bi bi-file-earmark-pdf-fill" />
                            </div>
                          </div>
                          <div className="w-75">
                            <div>
                              Youve uploaded <span className="font-bold">documentation.pdf</span> to
                              the <span className="font-bold">kms</span> project
                            </div>
                            <div className="d-flex gap-2 mt-2 ">
                              <div className="position-relative bg-light border border-dashed border-warning-hover rounded-pill">
                                <div className="py-2 px-3 d-flex align-items-center">
                                  <div className="me-2">
                                    <i className="bi bi-image text-warning" />
                                  </div>
                                  <div className="flex-fill">
                                    <a
                                      href="#"
                                      className="d-block font-semibold text-xs text-muted text-warning-hover stretched-link">
                                      documentation.pdf
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <small className="d-flex justify-content-end mb-1 text-muted">
                            2 hrs ago
                          </small>
                        </div>
                      </div>
                    </div>
                    <div className="list-group-item px-2 py-0">
                      <div className="border-start">
                        <div className="d-flex ms-n6 pb-6">
                          <div className="flex-none me-3">
                            <div className="icon icon-shape text-base w-12 h-12 bg-soft-primary text-primary rounded-circle">
                              <i className="bi bi-file-earmark-pdf-fill" />
                            </div>
                          </div>
                          <div className="flex-fill">
                            <small className="d-block mb-1 text-muted">4 hrs ago</small>
                            <div className="text-sm">
                              <span className="text-heading text-sm font-bold">Mike</span> added a
                              new comment to your task:
                            </div>
                            <div className="mt-2">
                              <p className="text-sm text-muted">
                                On the other hand, we denounce with righteous indignation and
                                dislike men who are so beguiled and demoralized by the charms of
                                pleasure of the moment, so blinded by desire, that they cannot
                                foresee.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="list-group-item px-2 py-0">
                      <div className="border-start">
                        <div className="d-flex ms-n6 pb-6">
                          <div className="flex-none me-3">
                            <div className="icon icon-shape text-base w-12 h-12 bg-soft-primary text-primary rounded-circle">
                              <i className="bi bi-file-earmark-pdf-fill" />
                            </div>
                          </div>
                          <div className="flex-fill">
                            <small className="d-block mb-1 text-muted">4 hrs ago</small>
                            <div className="text-sm">
                              Heather added <span className="font-bold">4 images</span> to the{' '}
                              <span className="font-bold">Team</span> album:
                            </div>
                            <div className="mt-2 d-flex gap-2 scrollable-x">
                              <div className="col-auto">
                                <img
                                  alt=""
                                  src="/img/media/img-3.jpg"
                                  className="rounded w-auto h-16"
                                />
                              </div>
                              <div className="col-auto">
                                <img
                                  alt=""
                                  src="/img/media/img-4.jpg"
                                  className="rounded w-auto h-16"
                                />
                              </div>
                              <div className="col-auto">
                                <img
                                  alt=""
                                  src="/img/media/img-5.jpg"
                                  className="rounded w-auto h-16"
                                />
                              </div>
                              <div className="col-auto">
                                <img
                                  alt=""
                                  src="/img/media/img-6.jpg"
                                  className="rounded w-auto h-16"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="list-group-item px-2 py-0">
                      <div className="border-start">
                        <div className="d-flex ms-n6 pb-6">
                          <div className="flex-none me-3">
                            <div className="icon icon-shape text-base w-12 h-12 bg-soft-primary text-primary rounded-circle">
                              <i className="bi bi-file-earmark-pdf-fill" />
                            </div>
                          </div>
                          <div className="flex-fill">
                            <small className="d-block mb-1 text-muted">4 hrs ago</small>
                            <div className="text-sm">
                              Heather added <span className="font-bold">Anna</span> to the{' '}
                              <span className="font-bold">Clever</span> team.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="list-group-item px-2 py-0">
                      <div className="border-start">
                        <div className="d-flex ms-n6 pb-6">
                          <div className="flex-none me-3">
                            <div className="icon icon-shape text-base w-12 h-12 bg-soft-primary text-primary rounded-circle">
                              <i className="bi bi-file-earmark-pdf-fill" />
                            </div>
                          </div>
                          <div className="flex-fill">
                            <small className="d-block mb-1 text-muted">4 hrs ago</small>
                            <div className="text-sm">
                              Heather created the tags
                              <div className="d-inline-block mx-1">
                                <a
                                  href="#"
                                  className="badge rounded-pill bg-danger bg-opacity-20 bg-opacity-100-hover text-danger text-white-hover">
                                  Bugs
                                </a>{' '}
                                <a
                                  href="#"
                                  className="badge rounded-pill bg-success bg-opacity-20 bg-opacity-100-hover text-success text-white-hover">
                                  Showcase
                                </a>
                              </div>
                              for the <span className="font-bold">Clever</span> project
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="list-group-item px-2 py-0">
                      <div>
                        <div className="d-flex ms-n6 pb-6">
                          <div className="flex-none me-3">
                            <div className="icon icon-shape text-base w-12 h-12 bg-soft-primary text-primary rounded-circle">
                              <i className="bi bi-file-earmark-pdf-fill" />
                            </div>
                          </div>
                          <div className="flex-fill">
                            <small className="d-block mb-1 text-muted">2 hrs ago</small>
                            <div>
                              Youve uploaded <span className="font-bold">documentation.pdf</span> to
                              the <span className="font-bold">kms</span> project
                            </div>
                            <div className="mt-2 scrollable-x overflow-hidden">
                              <div className="d-inline-block position-relative bg-light border border-dashed border-tertiary-hover rounded-pill">
                                <div className="py-2 px-3 d-flex align-items-center">
                                  <div className="me-2">
                                    <i className="bi bi-image text-tertiary" />
                                  </div>
                                  <div className="flex-fill">
                                    <a
                                      href="#"
                                      className="d-block font-semibold text-xs text-muted text-tertiary-hover stretched-link">
                                      design.fig
                                    </a>
                                  </div>
                                </div>
                              </div>
                              <div className="d-inline-block position-relative bg-light border border-dashed border-warning-hover rounded-pill">
                                <div className="py-2 px-3 d-flex align-items-center">
                                  <div className="me-2">
                                    <i className="bi bi-image text-warning" />
                                  </div>
                                  <div className="flex-fill">
                                    <a
                                      href="#"
                                      className="d-block font-semibold text-xs text-muted text-warning-hover stretched-link">
                                      readme.md
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          Graphss malevs female
                          ....
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </>
      )}
    </>
  );
}

export default EventOverview;
